import type { ArticleJson } from "../types/SemanticTypes";

export const jsonExporter = {
  export(article: ArticleJson): string {
    return JSON.stringify(article, null, 2);
  }
};
